import { createContext, useContext, useRef, type ReactNode } from 'react';
import { EditApplierRegistry } from './applier-registry';

export const AiComposerRegistryContext = createContext<EditApplierRegistry | null>(null);

export function AiComposerProvider({ children }: { children: ReactNode }) {
  const ref = useRef<EditApplierRegistry>(undefined);
  if (!ref.current) ref.current = new EditApplierRegistry();
  return <AiComposerRegistryContext.Provider value={ref.current}>{children}</AiComposerRegistryContext.Provider>;
}

export function useEditApplierRegistry(): EditApplierRegistry {
  const reg = useContext(AiComposerRegistryContext);
  if (!reg) throw new Error('useEditApplierRegistry must be used inside AiComposerProvider');
  return reg;
}
